import {makeStyles} from "@material-ui/core/styles";

export const  useStyles = makeStyles((theme) => ({
    dialogBox:{
        '& .MuiDialog-paper':{
            margin:0,
            background: 'white',
            boxShadow: '8px 8px 20px rgba(0, 0, 0, 0.25)',
            // padding: '12px 10px 0px',
            padding: '0px',
            borderRadius: '5px 5px 5px 5px',
            boxSizing: 'border-box',
            maxWidth: 1280
        },
        '& *':{
            fontFamily: 'NanumSquare',
        }
    },
    dialogTopBar: {
        alignItems:'center',
        display:'flex',
        justifyContent:'space-between',
    },
    titleText:{
        fontSize: '1rem',
        lineHeight: '22px',
        color: 'black',
        fontWeight: 600,
        padding: '10px 0 10px 17px',

    },
    iconButton:{
        padding: '9px 14px',
        '&:hover':{
            background: 'transparent'
        }
    },
    contentsBox:{
        background: '#fff',
        padding: 17,
        boxSizing: 'border-box'
    },
    controlBox:{
        marginTop: 15,
    },
    controlBoxText:{
        '& p':{
            fontSize: '0.875rem',
            color: '#1C1C1C',
            '& span':{
                color: '#f97564'
            }
        }
    },
    container: {
        // width: 1280,
        // margin: '0 auto',
        // paddingTop: '18px',
        minHeight: 'calc(100vh - 117px - 20px)',
        maxHeight: '100%'
    },
    buttonStyle:{
        minWidth: 80,
        height: 44,
        boxSizing: 'border-box',
        padding: '0 12px',
        background: '#5579f0',
        borderRadius: 5,
        marginLeft: 16,
        '& span':{
            color: '#fff',
            fontSize: '1rem',
            fontWeight: 600
        },
        '&:hover':{
            background: '#5579f0',
        },
        '&.Mui-disabled':{
            background: '#dbdbdb',
            color: '#b6b6b6',
            border: '1px solid #b6b6b6',
            '& span':{
                color: '#b6b6b6',
            }
        }
    },
    buttonStyleCancle: {
        background: 'rgba(16, 18, 28, 0.3)',
        color: '#fff',
        '&:hover':{
            background: 'rgba(16, 18, 28, 0.3)',
            color: '#fff',
        },
    }
}));

